import React, { useEffect } from 'react';
import styled from 'styled-components';

// Import components
import Header from '../components/Header';
import ProductShowcase from '../components/ProductShowcase';
import HydraulicExcavators from '../components/HydraulicExcavators';
import MiniExcavators from '../components/MiniExcavators';
import MotorGrader from '../components/MotorGrader';
import Bulldozers from '../components/Bulldozers';
import WheelLoaders from '../components/WheelLoaders';
import CompanyInfo from '../components/CompanyInfo';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';


const HomePage = () => {

  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
    
    // Check for hash in URL and scroll to that section if present
    const hash = window.location.hash;
    if (hash) {
      // Slight delay to ensure components are rendered
      setTimeout(() => {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 500);
    }
  }, []);
  

  return (
    <>
      <Header />
      <ProductShowcase />
      <HydraulicExcavators />
      <MiniExcavators />
      <MotorGrader />
      <Bulldozers />
      <WheelLoaders />
      <CompanyInfo />
      <ContactSection />
      <Footer />
      </>
  );
};

export default HomePage;